import { getFeature } from 'Cloud/Application/FeaturesEs6';

/** https://jira.vk.team/browse/CLOUDWEB-16858 Коммуникация про удаления файлов / Информирование об объёме корзины */
export const BIG_TRASHBIN_SIZE_INFO = getFeature('big-trashbin-size-info') || false;

/** CLOUDWEB-19199 - принудительное выключение */
export const FORCE_DISABLE_BIG_TRASHBIN_SIZE_INFO = getFeature('force-disable-big-trashbin-size-info') || false;
